// extracted by mini-css-extract-plugin
export default {"pager-btn":"Pager_pager-btn__KKv+Z","pager-num":"Pager_pager-num__ceup8"};